import React from 'react';
import SearchComponent from './SearchComponent';
import './App.css'; // Assume you have CSS for SearchSection

const SearchSection = () => {
  return (
    <div className="search-section">
      <SearchComponent />
    </div>
  );
};

export default SearchSection;
